var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ai-recommendations-head-border" }, [
    _c(
      "div",
      { staticClass: "ai-recommendations-head-left" },
      [
        _c("div", { staticClass: "ai-recommendations-head-left-title" }, [
          _vm._v("Based on AI recommendations")
        ]),
        _vm._v(" "),
        _vm.storeList && _vm.storeList.length > 0
          ? _c(
              "div",
              { staticClass: "ai-recommendations-head-left-subtitle" },
              [
                _vm._v(
                  "The primary focus of the store type is located in the United States:"
                )
              ]
            )
          : _c("div", { staticClass: "no-store-list" }, [
              _vm._v(
                "Based on your brand and positioning, we recommend a variety of stores to meet various needs: a total of 800 establishments."
              )
            ]),
        _vm._v(" "),
        _vm._l(_vm.storeList, function(item, index) {
          return _c(
            "div",
            { key: index, staticClass: "ai-recommendations-head-left-content" },
            [
              _c("img", {
                attrs: { src: require("@/assets/img/vilocal/ai-head-tag.png") }
              }),
              _c("span", [_vm._v(_vm._s(item.state))]),
              _c("span", [_vm._v(_vm._s(item.storeType))]),
              _c("span", [_vm._v(_vm._s(item.storeCount))]),
              _vm._v("store"),
              item.storeCount > 1 ? _c("span", [_vm._v("s")]) : _vm._e()
            ]
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "ai-recommendations-head-left-bottom" }, [
          _vm._v("The following details are from the stores.")
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ai-recommendations-head-right" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2507a50e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2507a50e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vilocal/ai-recommendations/ai-recommendations-head.vue
// module id = uGmi
// module chunks = 2